import React from 'react'
import { useParams } from 'react-router-dom'
import { CourseDetails } from '../containers/content/courses'

const CoursePage = () => {
  const { id } = useParams()
  if(!id) return <div>Invalid course id</div>
  return <CourseDetails id={id} />
}

export default React.memo(CoursePage)
